import Styles from '../plugins/styles/styles'
import '@fortawesome/fontawesome-free/css/all.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

import fr from 'vuetify/es5/locale/fr'

const fontSettings = {
  icons: {
    iconfont: 'md',
  },
}

// const themeSettings = {
//   theme: {
//     dark: false,
//     themes: {
//       light: {
//         primary: '#e91e63',
//         secondary: '#C4AFB1',
//         accent: '#BF7B7E',
//         // error: '#b71c1c',
//         // warning: '',
//         // info: '',
//         // success: '',
//         text: '#707070',
//         filArianeBg: '#EFE0E2',
//         selectPink: '#F7F0F1',
//         white: '#FCFCFE',
//         actifLink: '#FF4E6A',
//         headerDrawer: '#d8405d',
//         textLight: '#cecece',
//         label: '#a0a0a0',
//         green: '#45b197',
//         updatedGrey: '#C5AFB2',
//         inactiveItem: '#ff7474',
//         yellow: '#d4d41b',
//         rose: '#f06292',
//       },
//       dark: {
//         accent: '#F6C224',
//         error: 'EA473E',
//         inactiveItem: '#ff7474',
//         filArianeBg: '#EFE0E2',
//       },
//     },
//   },
// };

const langSettings = {
  lang: {
    locales: {
      fr,
    },
    current: 'fr',
  },
}

let vuetifySettings = {}
Object.assign(vuetifySettings, fontSettings)
Object.assign(vuetifySettings, {
  theme: { themes: Styles, options: { customProperties: true } },
})
Object.assign(vuetifySettings, langSettings)

Vue.use(Vuetify)
export default new Vuetify(vuetifySettings)
